import { Dispatch, SetStateAction } from 'react';
import { Form, Formik } from 'formik';

import { Modal } from '@shared/components/modals/Modal';
import { dateNow, productRulesValidationSchema } from '../constants';
import { ProductType, ProviderType, RuleType } from '../types';
import { ProductRulesForm } from './ProductRulesForm';

type ProductRulesModalProps = {
  productRulesModalPosition: number;
  setProductRulesModalPosition: React.Dispatch<React.SetStateAction<number>>;
  handleSubmit: (data: RuleType) => Promise<void>;
  currentRule: RuleType | null;
  providers: ProviderType[] | undefined;
  productTypes: ProductType[] | undefined;
  onChangeProvider: Dispatch<SetStateAction<string>>;
  providerId: string;
};

export const ProductRulesModal = ({
  productRulesModalPosition,
  setProductRulesModalPosition,
  handleSubmit,
  currentRule,
  providers,
  productTypes,
  onChangeProvider,
  providerId,
}: ProductRulesModalProps) => {
  const initialRuleState: RuleType = {
    id: currentRule?.id || '',
    providerId: currentRule?.providerId || '',
    productTypeId: currentRule?.productTypeId || '',
    assetTypes: currentRule?.assetTypes || '',
    startDate: currentRule?.startDate || dateNow,
    endDate: currentRule?.endDate || dateNow,
    ilendingCostAmount: currentRule?.ilendingCostAmount || null,
    ilendingCostFormula: currentRule?.ilendingCostFormula || '',
    packAmount: currentRule?.packAmount || null,
    packFormula: currentRule?.packFormula || '',
    markupAmount: currentRule?.markupAmount || null,
    markupFormula: currentRule?.markupFormula || '',
    state: currentRule?.state || '',
    minTerm: currentRule?.minTerm || null,
    maxTerm: currentRule?.maxTerm || null,
    minMileage: currentRule?.minMileage || '',
    maxMileage: currentRule?.maxMileage || '',
    minYear: currentRule?.minYear || '',
    maxYear: currentRule?.maxYear || '',
    scheduleDateRange: currentRule?.scheduleDateRange || '',
    planName: currentRule?.planName || '',
  };

  return (
    <Modal
      hideBackdrop
      title="Add / Edit rule"
      open={!!productRulesModalPosition} 
      resetPosition={productRulesModalPosition}
      dialogWidth="1000px"
      onClose={() => setProductRulesModalPosition(0)}
    >
      <Formik
        enableReinitialize
        initialValues={initialRuleState as RuleType}
        validationSchema={productRulesValidationSchema}
        onSubmit={handleSubmit}
      >
        {(props) => (
          <Form onSubmit={props.handleSubmit}>
            <ProductRulesForm
              {...props}
              providers={providers}
              productTypes={productTypes}
              providerId={providerId}
              handleClose={() => setProductRulesModalPosition(0)}
              onChangeProvider={onChangeProvider}
            />
          </Form>
        )}
      </Formik>
    </Modal>
  );
};
